import {createApp} from 'vue'
import ZakuProductRequest from './zaku-product-request-update.vue'
import i18nPlugin, {i18n, loadTranslations} from "./i18n";
import {createPinia} from 'pinia'

$.onmount('[data-vue=zaku-product-request-update]', async function () {
    const app = createApp(ZakuProductRequest)
    const pinia = await createPinia()
    app.config.unwrapInjectedRef = true
    app.use(pinia)
    app.use(i18nPlugin)
    await loadTranslations(i18n)
    app.mount(this)
})
